import "./Breadcrumb.scss";

import React from "react";

import HomeIcon from "@mui/icons-material/Home";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";

import { FeatureToggle } from "../../models/app-data-model";
import { getBreadCrumbData } from "../../services/breadcrumb-generator";
import PhLink from "../ph-link/ph-link";

export type BreadcrumbProps = {
  featureToggles: FeatureToggle[];
  url: string;
};

const Breadcrumb: React.FC<BreadcrumbProps> = (props: BreadcrumbProps) => {

  const url = props.url;
  const breadCrumbData = getBreadCrumbData(url);
  const breadCrumbs = breadCrumbData.map((crumb, index) => <Link underline="hover" sx={{ display: 'flex', alignItems: 'center' }} key={index} href={crumb?.url}>{crumb?.title}</Link>)

  // we need to add the aria-label to the ph-link component
  return <nav aria-label="breadcrumb trail"><Breadcrumbs maxItems={4} separator="›" aria-label="breadcrumb" itemsBeforeCollapse={3}>
    <PhLink sx={{ display: 'flex', alignItems: 'center' }} href="/" aria-label="Back to the homepage"><HomeIcon sx={{ mr: 0.5 }} /></PhLink>
    {breadCrumbs}
  </Breadcrumbs></nav>;

};

export default Breadcrumb;
